var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parlamentar-header"},[_c('h2',[_vm._v("Vereador")]),_c('h2',[_vm._v("Partido")])])}]

export { render, staticRenderFns }